import StringMixin from "@/components/mixins/StringMixin";

export default {
    chart: {
        toolbar: {
            show: false
        },
    },
    plotOptions: {
        bar: {
            horizontal: false,
            columnWidth: '55%',
            endingShape: 'rounded',
        },
    },
    responsive: [
        {
            breakpoint: 1200,
            options: {
                chart: {
                    height: '80%',
                },
            }
        }
    ],
    colors: [],
    dataLabels: {
        enabled: false
    },
    stroke: {
        show: true,
        width: 2,
        colors: ['transparent']
    },
    xaxis: {
        categories: [],
    },
    yaxis: {
        tickAmount: 4,
        decimalsInFloat: 0,
    },
    fill: {
        opacity: 1
    },
    tooltip: {
        shared: true,
        intersect: false,
        y: {
            formatter: (value) => {
                const number = Number(value).toFixed(0)
                return `€ ${StringMixin.methods.getEuropeanNumberFormat(number)}`
            },
        }
    },
};
